var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectionCampaign = function SvgElectionCampaign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.459 7.951c2.1-.995 5.149-5.8 5.149-5.8l4.292 9.07s-5.642-.682-7.744.312l-1.075.509a1.982 1.982 0 0 1-1.7-3.582z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 3.75,
    cy: 14.25,
    r: 2.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 19.612a2.83 2.83 0 0 0-1.5 2.638v1m6.5 0v-1.763c2.944-1.337 5-3.3 5-6.737a1.5 1.5 0 0 0-3 0c0 1.926-1 2.625-2.5 3.608M19.25 5.25l2.5-1.5m-4-1 2-2m.5 7 3-.5"
  })));
};
export default SvgElectionCampaign;